import { useRef, useLayoutEffect } from 'react';

const useOverrideComponentStyles = (styles) => {
    const ref = useRef(null);

    useLayoutEffect(() => {
        if (!ref.current) {
            return () => {};
        }

        const styleElement = document.createElement('style');
        styleElement.innerHTML = styles;

        // Save current ref in a local variable, so it is available in the cleanup function
        const targetElement = ref.current;
        targetElement.shadowRoot.appendChild(styleElement);

        return () => {
            targetElement.shadowRoot.removeChild(styleElement);
        };
    }, [styles]);

    return ref;
};

export default useOverrideComponentStyles;
